import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, OutlinedInput, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { sxButtons, sxCloseIconButton, sxModal, sxInput, sxLabel, sxTitleModal } from './sxProps';
import DefaultTextBold from '../../../../../components/Accessibility/DefaultTextBold';
import DefaultButton from '../../../../../components/Accessibility/DefaultButton';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../../../../components/Accessibility/PageTitle';
import DefaultText from '../../../../../components/Accessibility/DefaultText';
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons';
import { Agendamento } from '../../../../../interfaces/entities/Agendamento';


interface Props {
    showModal: boolean;
    onVoltarClick: () => void;
    onConfirmarClick: (agendamento: Agendamento | null) => void;
    agendamento: Agendamento | null;
}

const CancelarModal: React.FC<Props> = ({
  showModal, onVoltarClick, onConfirmarClick, agendamento
}) => {

  const accessibility = useAccessibility();

  return (
    <Modal
      open={showModal}
    >
      <Box sx={sxModal} style={{...accessibility.textStyleAccessibility, ...accessibility.contrastBorderAccessibility}}>
        <IconButton
          aria-label="fechar"
          onClick={onVoltarClick}
          sx={sxCloseIconButton}
          >
            <FontAwesomeIcon icon={faTimes} size="1x" color='black' style={accessibility.textStyleAccessibility} />
          </IconButton>
          <FontAwesomeIcon icon={faTriangleExclamation} color='#F8AC75' size='3x' />          
          <DefaultText sx={{color: '#383838', fontFamily: 'UnimedSans-Bold', fontSize: '20px'}} component="h1" marginBottom="15px" text="Cancelar agendamento" />
          <DefaultText alignCenter text={`Tem certeza que deseja cancelar o atendimento para ${agendamento?.dataAgendamento}, às ${agendamento?.horaAgendamento} com ${agendamento?.nomeMedico}?`}/>
          <Box sx={sxButtons}>
            <DefaultButton text="Voltar" variant="outlined" onClick={onVoltarClick} />
            <DefaultButton text="Cancelar agendamento" sx={{backgroundColor: '#d32f2f'}} onClick={() => onConfirmarClick(agendamento)} />
          </Box>
      </Box>
    </Modal>
  );
};

export default CancelarModal;
